const base = {
  persistConfig: {
    active: true,
    reducerVersion: "1",
    blacklist: [], // reducer keys that you do NOT want stored to persistence here
    whitelist: ["auth", "user"], // Optionally, just specify the keys you DO want stored to
    transforms: []
  },
  validRoles: {
    ROLE_USER: true,
    ROLE_GESTOR: true,
    ROLE_SUPERVISOR_MONITOR: true,
    ROLE_ADMIN: true,
    ROLE_ALL_VIEW: true,
    ROLE_ACTION_PLAN_VIEW: true,
    ROLE_DASHBOARD_VIEW: true,
    ROLE_REPORT_VIEW: true,
    ROLE_DASHBOARD_DISABLED: true,
    ROLE_COCREACION_DISABLED: true,
    ROLE_ALERT_DISABLED: true,
    ROLE_ACTION_PLAN_DISABLED: true,
    ROLE_REPORT_DISABLED: true,
    ROLE_SOCIAL_MEDIA_DISABLED: true
  },

  rolesMap: {
    ROLE_ALL_VIEW: "visitor",
    ROLE_USER: "visitor",
    ROLE_DASHBOARD_VIEW: "visitor",
    ROLE_REPORT_VIEW: "visitor",
    ROLE_DASHBOARD_DISABLED: "visitor",
    ROLE_COCREACION_DISABLED: "visitor",
    ROLE_ALERT_DISABLED: "visitor",
    ROLE_ACTION_PLAN_DISABLED: "visitor",
    ROLE_REPORT_DISABLED: "visitor",
    ROLE_SOCIAL_MEDIA_DISABLED: "visitor",
    ROLE_GESTOR: "monitor",
    ROLE_SUPERVISOR_MONITOR: "admin",
    ROLE_ADMIN: "superadmin",
    ROLE_ACTION_PLAN_VIEW: "Action Plan"
  },

  avialbesRoles: {
    ROLE_DIRECTOR: "Director",
    ROLE_GERENTE: "Gerente",
    ROLE_JEFE_MONITOR: "Jefe Monitor",
    ROLE_SUPERVISOR_MONITOR: "Supervisor Monitor",
    ROLE_MONITOR: "Monitor",
    ROLE_GESTOR: "Gestor",
    ROLE_ALL_VIEW: "Visitante",
    ROLE_DASHBOARD_VIEW: "Visitante",
    ROLE_REPORT_VIEW: "Visitante",
    ROLE_DASHBOARD_DISABLED: "Visitante",
    ROLE_COCREACION_DISABLED: "Visitante",
    ROLE_ALERT_DISABLED: "Visitante",
    ROLE_ACTION_PLAN_DISABLED: "Visitante",
    ROLE_REPORT_DISABLED: "Visitante",
    ROLE_SOCIAL_MEDIA_DISABLED: "Visitante",
    ROLE_USER: "Usuario",
    ROLE_ACTION_PLAN_VIEW: "Plan de acción (solo lectura)"
  },

  roleHierarchy: {
    ROLE_DIRECTOR: null,
    ROLE_GERENTE: "ROLE_DIRECTOR",
    ROLE_JEFE_MONITOR: "ROLE_GERENTE",
    ROLE_SUPERVISOR_MONITOR: "ROLE_JEFE_MONITOR",
    ROLE_MONITOR: "ROLE_SUPERVISOR_MONITOR",
    ROLE_GESTOR: "ROLE_MONITOR",
    ROLE_USER: "ROLE_GESTOR",
    ROLE_ALL_VIEW: "ROLE_USER",
    ROLE_DASHBOARD_VIEW: "ROLE_ALL_VIEW",
    ROLE_REPORT_VIEW: "ROLE_ALL_VIEW",
    ROLE_ACTION_PLAN_VIEW: "ROLE_ALL_VIEW",
    ROLE_DASHBOARD_DISABLED: "ROLE_ALL_VIEW",
    ROLE_COCREACION_DISABLED: "ROLE_ALL_VIEW",
    ROLE_ALERT_DISABLED: "ROLE_ALL_VIEW",
    ROLE_ACTION_PLAN_DISABLED: "ROLE_ALL_VIEW",
    ROLE_REPORT_DISABLED: "ROLE_ALL_VIEW",
    ROLE_SOCIAL_MEDIA_DISABLED: "ROLE_ALL_VIEW"
  }
};

export default base;



// WEBPACK FOOTER //
// ./src/config/base.js